import { render, staticRenderFns } from "./ActionsButton.vue?vue&type=template&id=710e671f&scoped=true&"
import script from "./ActionsButton.vue?vue&type=script&lang=js&"
export * from "./ActionsButton.vue?vue&type=script&lang=js&"
import style0 from "./ActionsButton.vue?vue&type=style&index=0&id=710e671f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e671f",
  null
  
)

export default component.exports